export interface Student {
    id: string;
    user_id: string;
    student_id: string;
    nisn?: string;
    birth_date?: string;
    gender?: string;
    phone?: string;
    address?: string;
    emergency_contact?: string;
    emergency_phone?: string;
    current_class_id?: string;
    user: {
        id: string;
        name: string;
        email: string;
    };
    current_class?: {
        id: string;
        name: string;
        grade_level: string;
    };
    created_at: string;
    updated_at: string;
}

export interface CreateStudentData {
    name: string;
    email: string;
    nisn?: string;
    phone?: string;
    address?: string;
    gender?: string;
    birth_date?: string;
    emergency_contact?: string;
    emergency_phone?: string;
}

export interface UpdateStudentData {
    name?: string;
    email?: string;
    nisn?: string;
    phone?: string;
    address?: string;
    gender?: string;
    birth_date?: string;
    emergency_contact?: string;
    emergency_phone?: string;
}

export interface StudentFilters {
    current_class_id?: string;
    search?: string;
    gender?: string;
    status?: string;
    page?: number;
    per_page?: number;
    sort_by?: string;
    sort_order?: "asc" | "desc";
}

import api from "./axios";

export interface StudentListResponse {
    success: boolean;
    message: string;
    data: {
        items: Student[];
        meta: {
            current_page: number;
            last_page: number;
            per_page: number;
            total: number;
            from: number;
            to: number;
        };
    };
}

export interface StudentResponse {
    success: boolean;
    message: string;
    data: Student;
}

export const studentApi = {
    async getAll(filters: StudentFilters = {}): Promise<StudentListResponse> {
        const response = await api.get("/v1/students", { params: filters });
        return response.data;
    },

    async getById(id: string): Promise<StudentResponse> {
        const response = await api.get(`/v1/students/${id}`);
        return response.data;
    },

    async create(data: CreateStudentData): Promise<StudentResponse> {
        const response = await api.post("/v1/students", data);
        return response.data;
    },

    async update(
        id: string,
        data: UpdateStudentData,
    ): Promise<StudentResponse> {
        const response = await api.put(`/v1/students/${id}`, data);
        return response.data;
    },

    async delete(id: string): Promise<void> {
        await api.delete(`/v1/students/${id}`);
    },

    async getByClass(
        classId: string,
    ): Promise<{ success: boolean; message: string; data: Student[] }> {
        const response = await api.get(`/v1/students/class/${classId}`);
        return response.data;
    },

    async importStudents(
        file: FormData,
    ): Promise<{ success: boolean; message: string; data: any }> {
        const response = await api.post("/v1/students/import", file, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    },
};

export default studentApi;
